import React from 'react';
import {wrapper} from "../../store";
import {getRunningQueriesThunk, getUpdate, useGetUpdateQuery} from "../../api/updates";
import Layout from "../../components/Layout";
import {NextSeo} from "next-seo";
import {handleStatusCode} from "../../helpers/utils";


export const getServerSideProps = wrapper.getServerSideProps(store => async ({req, params}) => {
	const {id} = params
	let errorStatus;
	store.dispatch(getUpdate.initiate(id)).then((data) => errorStatus = data.error?.status);
	await Promise.all(store.dispatch(getRunningQueriesThunk()));
	if (errorStatus !== undefined) {
		return handleStatusCode(errorStatus)
	}

	return {
		props: {id},
	};
});


function Index({ id }) {
	const { data:update } = useGetUpdateQuery(id)
	
	function createMarkup(data) {
		return {__html: data};
	}
	
	return (
		<Layout>
			<NextSeo
				title={`${update?.data.title} - PageName Updates`}
				description={`${update?.data.preview_text}`}
				openGraph={{
					type: 'website',
					url: process.env.NEXT_PUBLIC_BLOG_URL + '/' + id,
					title: `${update?.data.title} - PageName Blog`,
					description: `${update?.data.preview_text}`,
					images: [
						{
							url: process.env.NEXT_PUBLIC_UPDATES_URL + '/images/og-image.png',
							width: 1200,
							height: 641,
							alt: `View all our site updates and release notes here`,
							type: 'image/png',
						}
					],
					siteName: 'PageName',
				}}
				twitter={{
					site: '@pagenamer',
					cardType: 'summary_large_image',
				}}
			/>
			<div class="mx-auto flex flex-wrap py-6 bg-gray-100 pb-40">
				<div class="mx-auto container">
					<section class="w-full md:w-2/3 flex flex-col items-center px-3">
						
						<article class="flex flex-col shadow my-4 w-full">
							<div class="bg-white flex flex-col justify-start p-6">
								{/*<a href="#" className="text-blue-700 text-sm font-bold uppercase pb-4">Technology</a>*/}
								<h1 className="text-3xl font-bold pb-4">{update?.data.title}</h1>
								<p class="text-sm pb-3">
									Published on <span className="text-sm" suppressHydrationWarning>{new Date(update?.data.created_at).toLocaleDateString('en-us', {  year:"numeric", month:"long", day:"numeric"}) }</span>
								</p>
								<div  className="pb-6 w-full post-body" dangerouslySetInnerHTML={createMarkup(update?.data.body)} />
							</div>
						</article>
					</section>
					
					<aside class="w-full md:w-1/3 flex flex-col items-center px-3">
					
					</aside>
				</div>
			</div>
		</Layout>
	);
}

export default Index;
